import React, { FunctionComponent, useState, useEffect } from 'react';
import { Accordion, Nav, Col, Image, Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCode, faUserCircle, faChartBar, faMoneyBillAlt, faPaperPlane, faHandLizard } from '@fortawesome/fontawesome-free-regular';
import SupportBanner from '../../DashboardComponents/supportBanner';
import PlansBanner from '../../DashboardComponents/plansBanner';


// ESTE ES EL SIDEBAR DE LOS DOCUMENTOS

type SideProps = {
  sider: any,
  active?: string,
  cambio?: ()=>void
};

const ApiSideBar:FunctionComponent<SideProps> = ({ sider, active, cambio }) => {

  const [navMenu, setNav] = useState([]);
  const [expanded, setExpanded] = useState('');
  const urlPathName = window.location.pathname;
  const { urlBase, menus } = sider;

  const history = useHistory();

  const routerLink = (e) => {
    e.preventDefault();
    e.stopPropagation();
    history.push(e.currentTarget.pathname);
    cambio();
  }

  
  const loadNav = () => {
    const navs = menus.map((nav) => {
      const { id, links, icon, title } = nav;
      const { basePath } = sider;
      return (
        <Nav className="flex-column mb-2">
            <div className={`px-0 title-nav ${expanded == id ? 'link-active': ''}`}>
              {nav.icon &&
                <img className={'pr-2'} src={`/src/assets/img/iconosv2/icon-${icon}.png`} />
              }  
              <div onClick={() => setExpanded(id)}>{title}</div>
            </div>
          {expanded === id && (
            <div>
            <Nav.Item className="ml-4">
              {links.map(link => {
                const { title, path } = link;
                const url = `${basePath || '/'}${id}/${path}`;
                return <Nav.Link className={'pl-2'} href={url} onClick={routerLink}><span>{title}</span></Nav.Link>;
              })}
            </Nav.Item>
          </div>
          )}

        </Nav>
      )
    })
    setNav(navs);
  }

  useEffect(()=> {
    loadNav();
    const defaultActive = menus[0].id;
    setExpanded(defaultActive);
  }, []);

  useEffect(()=> {
    loadNav();
  }, [expanded]);


  return (
    <div  id="sidebar" className="pl-4 pt-4">
      <Accordion defaultActiveKey={active || ''}>
        {navMenu}
        <PlansBanner/>
      </Accordion>
    </div>
  )
}

export default ApiSideBar;